
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/saaszilla",
      function () {
        return require("private-next-pages/saaszilla.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/saaszilla"])
      });
    }
  